
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/integrations/yclients",
      function () {
        return require("private-next-pages/[locale]/integrations/yclients.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/integrations/yclients"])
      });
    }
  